/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DecryptTextCommand = {
  encryptedTexts?: Array<string>;
  cryptoType?: DecryptTextCommand.cryptoType;
};
export namespace DecryptTextCommand {
  export enum cryptoType {
    KSW = 'KSW',
    HSW = 'HSW',
  }
}

